var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/brand",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,8 L8.818,8 L8.818,5 L5,5 L5,8 Z M5,13 L8.818,13 L8.818,10 L5,10 L5,13 Z M8.818,15 L5,15 L5,17.091 C5,18.144 5.856,19 6.909,19 C7.962,19 8.818,18.144 8.818,17.091 L8.818,15 Z M10.818,17.091 C10.818,19.246 9.064,21 6.909,21 C4.754,21 3,19.246 3,17.091 L3,4 C3,3.447 3.447,3 4,3 L9.818,3 C10.371,3 10.818,3.447 10.818,4 L10.818,17.091 Z M18.189,9.3 L14.054,5.443 C13.86,5.263 13.61,5.153 13.337,5.176 C13.072,5.185 12.821,5.299 12.641,5.493 L11.818,6.375 L11.818,9.308 L11.818,14.668 L11.818,17.091 C11.818,17.286 11.783,17.473 11.761,17.662 L18.239,10.713 C18.616,10.31 18.594,9.677 18.189,9.3 L18.189,9.3 Z M21,14.182 L21,20 C21,20.553 20.553,21 20,21 L10.017,21 L10.466,20.518 L11.881,19 L15.44,15.182 L17.305,13.182 L20,13.182 C20.553,13.182 21,13.629 21,14.182 L21,14.182 Z",
    id: "\\uD83C\\uDFA8-Icon-\\u0421olor",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand);
export default __webpack_public_path__ + "static/media/brand.f9d8585b.svg";
export { ForwardRef as ReactComponent };